<template src="../templates/normal_fcont_124.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import CreativePrintInText from '../components/CreativePrintInText'

import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import CreatorProfileItsuka from "../components/CreatorProfileItsuka"
import AppDownloadCreative from '../components/AppDownloadCreative';

import { Carousel,Slide } from 'uiv'
import { mapState } from "vuex";

export default {
  name: 'app',
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,FuncSearchGalleryQR,CreativePrintInText,
    CreatorProfileItsuka,AppDownloadCreative
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  computed: {
      ...mapState(["os"]),
      isMobile: function () {
          return this.os == 'ios' || this.os == 'ard'
      }
  },
  
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['124-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['124-2']}
    ]};
  }
  
};
</script>
<style >
</style>

